// 运行时配置
import * as Sentry from '@sentry/react';
import type { QueryClientConfig } from '@tanstack/query-core';
import { Button, ErrorBlock } from 'antd-mobile';
import React from 'react';
import { errorConfig } from './requestErrorConfig';

Sentry.init({
  dsn: 'https://e98ea02e4082fcfa9d058ec2160b8b0a@jk.hcsw.work:6121/9',
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [/^https:\/\/ali\.hcsw\.ltd/],
    }),
    new Sentry.Replay(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// 全局初始化数据配置，用于 Layout 用户信息和权限初始化
// 更多信息见文档：https://umijs.org/docs/api/runtime-config#getinitialstate
export async function getInitialState() {
  // const result = await userSummary();
  // const { data } = result;
  // Sentry.setUser(data.user);
  // return data;
}

// export const layout = () => {
//   return {
//     logo: 'https://img.alicdn.com/tfs/TB1YHEpwUT1gK0jSZFhXXaAtVXa-28-27.svg',
//     menu: {
//       locale: false,
//     },
//   };
// };

/**
 * 配置react Query
 */
const RETRY_MAX_COUNT = 0;
export const reactQuery: { queryClient: QueryClientConfig } = {
  queryClient: {
    defaultOptions: {
      queries: {
        retry(failureCount) {
          return failureCount < RETRY_MAX_COUNT;
        },
        refetchOnWindowFocus: false,
        suspense: true,
      },
    },
  },
};

/**
 * @name onRouteChange 路由切换
 * @doc https://umijs.org/docs/api/runtime-config#onroutechange
 */
export const onRouteChange = () => {
  document.documentElement.scrollTop = document.body.scrollTop = 0;
};

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request = {
  ...errorConfig,
};

export const rootContainer = (container: React.ReactNode) => {
  const props = {
    showDialog: true,
    fallback: ({ error }) => {
      Sentry.captureException(error);
      return (
        <React.Fragment>
          <div className={'text-center pt-10 px-4'}>
            <ErrorBlock
              title="我们遇到了一些问题"
              description="我们遇到了一些预料之外的问题，请联系您的服务顾问获取帮助或点击下方按钮重试"
            >
              <div className="desc">
                <Button
                  color="primary"
                  fill="none"
                  onClick={() => {
                    location.reload();
                  }}
                >
                  刷新重试
                </Button>
                <div className="mt-4">
                  <p className="font-semibold">以下是具体错误信息:</p>
                </div>
                <div>{error.toString()}</div>
              </div>
            </ErrorBlock>
          </div>
        </React.Fragment>
      ) as React.ReactNode;
    },
  } as Sentry.ErrorBoundaryProps;
  return React.createElement(Sentry.ErrorBoundary, props, container);
};
